// client/src/components/gallery/ItemGallery.js
import React, { useState, useEffect } from 'react';
import {
  Box, Typography, CircularProgress, Button, Grid
} from '@mui/material';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import PhotoCard from './PhotoCard';
import axiosInstance from '../../axiosInstance';
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext';

/**
 * Props: collectionType, itemId, currentUserId, collectionItemId (if user owns it)
 */
export default function ItemGallery({ collectionType, itemId, currentUserId, collectionItemId }) {
  const { isFeatureEnabled } = useFeatureFlags();
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);

  useEffect(() => {
    if (!isFeatureEnabled('enableItemGallery')) return;
    if (!itemId) return;
    axiosInstance.get(`/photos/item/${collectionType}/${itemId}?page=${page}`)
      .then(res => {
        setPhotos(p => page === 1 ? res.data.photos : [...p, ...res.data.photos]);
        setPages(res.data.pages);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [collectionType, itemId, page]);

  if (!isFeatureEnabled('enableItemGallery')) return null;

  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="h6">Photos</Typography>
        {collectionItemId && (
          <Button
            size="small"
            variant="outlined"
            startIcon={<AddPhotoAlternateIcon />}
            component="label"
          >
            Upload photo
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={async (e) => {
                const file = e.target.files[0];
                if (!file) return;
                // Image upload handled via existing MinIO/image-service pipeline
                // POST to /api/image-service/upload to get imageUrl, then POST /api/photos
                console.log('Image upload: wire to existing image-service upload pipeline');
              }}
            />
          </Button>
        )}
      </Box>
      {loading && page === 1 ? (
        <CircularProgress size={24} />
      ) : photos.length === 0 ? (
        <Typography color="text.secondary" variant="body2">No photos yet.</Typography>
      ) : (
        <>
          <Grid container spacing={2}>
            {photos.map(p => (
              <Grid item xs={12} sm={6} key={p._id}>
                <PhotoCard photo={p} currentUserId={currentUserId} />
              </Grid>
            ))}
          </Grid>
          {page < pages && (
            <Button onClick={() => setPage(p => p + 1)} sx={{ mt: 1 }}>Load more</Button>
          )}
        </>
      )}
    </Box>
  );
}
